"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_suspender_1 = __importDefault(require("react-suspender"));
const client_1 = require("../../client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
function MapmakerBeginCollaborateEndpoint() {
    const { gotoFindMap, gotoEditFile } = (0, client_1.useMapmakerAppConfig)();
    const { data, loading } = (0, MapmakerApi_1.useGetDesignsAndFilesQuery)();
    if (loading) {
        return (0, jsx_runtime_1.jsx)(react_suspender_1.default, {});
    }
    if (data.files.length === 1) {
        gotoEditFile(data.files[0].id, "collaborate");
    }
    else {
        gotoFindMap();
    }
    return null;
}
exports.default = MapmakerBeginCollaborateEndpoint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJCZWdpbkNvbGxhYm9yYXRlRW5kcG9pbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L01hcG1ha2VyQmVnaW5Db2xsYWJvcmF0ZUVuZHBvaW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxzRUFBd0M7QUFDeEMseUNBQW9EO0FBQ3BELDBEQUFzRTtBQUV0RSxTQUF3QixnQ0FBZ0M7SUFDdEQsTUFBTSxFQUFFLFdBQVcsRUFBRSxZQUFZLEVBQUUsR0FBRyxJQUFBLDZCQUFvQixHQUFFLENBQUM7SUFDN0QsTUFBTSxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsR0FBRyxJQUFBLHdDQUEwQixHQUFFLENBQUM7SUFFdkQsSUFBSSxPQUFPLEVBQUU7UUFDWCxPQUFPLHVCQUFDLHlCQUFTLEtBQUcsQ0FBQztLQUN0QjtJQUVELElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQzNCLFlBQVksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxhQUFhLENBQUMsQ0FBQztLQUMvQztTQUFNO1FBQ0wsV0FBVyxFQUFFLENBQUM7S0FDZjtJQUNELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQztBQWRELG1EQWNDIn0=